module.exports = __webpack_public_path__ + "static/media/icon-hiring-white.7d91c447.svg";